export default "__VITE_ASSET__DrTojxR2__"